import React from "react";
import classes from './Svg.module.css';

const Svg5 = () =>{
    return (
        <div className={classes['container']}>
            <svg className={classes['svg-img']} preserveAspectRatio="xMidYMid meet" data-bbox="28.5 39.5 143 120.9" viewBox="28.5 39.5 143 120.9" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="color" role="presentation" aria-hidden="true" aria-label="">
                <g>
                    <path d="M149.5 52.1H72.9v-7.9c0-2.8-2-4.7-4.3-4.7H48.9c-2.4 0-4.3 2-4.3 4.7v8.6c-9 2.4-16.1 11-16.1 21.2v64.4c0 12.2 9.8 22 22 22h99c12.2 0 22-9.8 22-22V74.1c0-12.2-9.8-22-22-22zm10.2 55.8h-22c-.4 20.4-17.3 37.3-37.7 37.3s-37.7-16.5-37.7-37.3h-22V74.1c0-5.9 4.7-10.2 10.2-10.2h99c5.9 0 10.2 4.7 10.2 10.2v33.8z" fill="#e65439" data-color="1"></path>
                    <path fill="#e65439" d="M153.1 80.4a7.9 7.9 0 1 1-15.8 0 7.9 7.9 0 0 1 15.8 0z" data-color="1"></path>
                    <path d="M100 78.8c-15.7 0-28.3 12.6-28.3 28.3s12.6 28.3 28.3 28.3 28.3-12.6 28.3-28.3c0-15.7-12.6-28.3-28.3-28.3zm16.9 27.9H83.1v-1.6c0-9.4 7.5-16.9 16.9-16.9s16.9 7.5 16.9 16.9v1.6z" fill="#e65439" data-color="1"></path>
                </g>
            </svg>
            <p className={classes['svg-text']}>Pro Photographers for best possible candids</p>             
        </div>
    )
}

export default Svg5;